import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RbacService {

  constructor(private api: ApiService) { }

  getAllRoles(data: any): Observable<any> {
    return this.api.post(environment.getAllRoles, data);
  }

  createRole(data: any): Observable<any> {
    return this.api.post(environment.createRole, data);
  }

  updateRole(data: any): Observable<any> {
    return this.api.post(environment.updateRole, data);
  }

  deleteRole(data: any): Observable<any> {
    return this.api.post(environment.deleteRole, data);
  }

  getAllPermissions(data: any = {}): Observable<any> {
     return this.api.post(environment.getAllPermissions, data);
  }
}
